/* eslint-disable no-bitwise */
import React, { useEffect, useState } from 'react'
import { Input, Segment } from 'semantic-ui-react'
import { AppDropdown as Dropdown } from 'components/AppDropdown'
import { CompanyInvoiceSettingService } from 'utility/services/company-invoice-setting'
import { useNotification } from 'hooks'
import { SubmitCancelButtons } from 'elements';

const formatBuilderStyles = `
.format-builder-wrap {
  background: #ffffff;
  border: 1px solid #eaecf0;
  border-radius: 12px;
  padding: 24px;
  margin-top: 16px;
  margin-bottom: 24px;
  font-family: inherit;
}
.format-builder-wrap h1 {
  font-size: 16px !important;
  font-weight: 600 !important;
  color: #101828 !important;
  margin: 0 0 4px 0 !important;
}
.format-builder-wrap .subtitle {
  font-size: 13px;
  color: #667085;
  margin-bottom: 20px;
}
.fb-card {
  background: #ffffff;
  border: 1px solid #f2f4f7;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 16px;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.04);
}
.fb-card.preview-card {
  background: #fcfcfd;
  border: 1px solid #eaecf0;
}
.preview-label {
  font-size: 11px;
  font-weight: 600;
  color: #344054;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
}
.preview-box {
  background: linear-gradient(135deg, #2d3748 0%, #1a202c 100%);
  color: #68d391;
  padding: 24px;
  border-radius: 10px;
  font-family: monospace;
  font-size: 26px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-align: center;
  word-break: break-all;
}
.preview-sub {
  font-size: 12px;
  color: #475467;
  margin-bottom: 16px;
  width: 100%;
  text-align: center;
}
.format-string-label {
  font-size: 11px;
  font-weight: 600;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}
.format-string {
  font-size: 14px;
  font-weight: 600;
  color: #475467;
  font-family: monospace;
  background: #f2f4f7;
  padding: 8px 12px;
  border-radius: 6px;
  display: inline-block;
}
.row-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.fb-row {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: #ffffff;
  border: 1px solid #eaecf0;
  border-radius: 8px;
  transition: all 0.2s ease;
  user-select: none;
}
.fb-row.dragging {
  opacity: 0.5;
  background: #f9fafb;
  border-style: dashed;
}
.fb-row.disabled {
  background: #f8f9fa;
  border-color: #eaecf0;
  opacity: 0.75;
}
.drag-handle {
  font-size: 18px;
  color: #98a2b3;
  margin-right: 16px;
  cursor: grab;
  font-weight: bold;
}
.fb-row:not(.disabled) .drag-handle:active {
  cursor: grabbing;
}
.fb-toggle {
  width: 40px;
  height: 20px;
  background: #eaecf0;
  border-radius: 10px;
  position: relative;
  cursor: pointer;
  transition: background 0.2s ease;
  margin-right: 16px;
  flex-shrink: 0;
}
.fb-toggle.on {
  background: #12b76a;
}
.fb-toggle-knob {
  width: 14px;
  height: 14px;
  background: #ffffff;
  border-radius: 50%;
  position: absolute;
  top: 3px;
  left: 3px;
  transition: transform 0.2s ease;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.06);
}
.fb-toggle.on .fb-toggle-knob {
  transform: translateX(20px);
}
.row-label {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  font-size: 14px;
  font-weight: 500;
  color: #344054;
}
.row-label .hint {
  font-size: 12px;
  font-weight: 400;
  color: #667085;
  margin-top: 2px;
}
.row-control {
  margin-left: 16px;
  flex-shrink: 0;
}
.row-control input[type="text"],
.row-control select,
.global-row input[type="text"],
.global-row select {
  border: 1px solid #d0d5dd;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 13px;
  color: #344054;
  outline: none;
  background: #ffffff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  min-width: 160px;
}
.row-control input[type="text"]:focus,
.row-control select:focus,
.global-row input[type="text"]:focus,
.global-row select:focus {
  border-color: #84caff;
  box-shadow: 0px 0px 0px 3px rgba(132, 202, 255, 0.25);
}
.fb-row.disabled .row-control input,
.fb-row.disabled .row-control select {
  background: #f2f4f7;
  color: #98a2b3;
  cursor: not-allowed;
}
.global-section {
  border-top: 1px solid #eaecf0;
  margin-top: 20px;
  padding-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.global-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.global-row .row-label {
  flex-grow: 1;
}
`;

// Helper value mappings
const mapCustomerFormatToValue = (fmt) => {
    if (fmt === 1) return 'initials'
    if (fmt === 2) return 'full'
    return 'initials'
}
const mapCustomerValueToFormat = (val) => {
    if (val === 'initials') return 1
    if (val === 'full') return 2
    return 1
}

const mapYearFormatToValue = (fmt) => {
    if (fmt === 0) return 'YYYY'
    if (fmt === 1) return 'YY'
    if (fmt === 2) return 'FY-YYYY'
    if (fmt === 3) return 'FY-YY'
    return 'YYYY'
}
const mapYearValueToFormat = (val) => {
    if (val === 'YYYY') return 0
    if (val === 'YY') return 1
    if (val === 'FY-YYYY') return 2
    if (val === 'FY-YY') return 3
    return 0
}

const mapResetModeToValue = (mode) => {
    if (mode === 0) return 'never'
    if (mode === 1) return 'calendar'
    if (mode === 2) return 'fiscal'
    if (mode === 3) return 'monthly'
    return 'never'
}
const mapResetValueToMode = (val) => {
    if (val === 'never') return 0
    if (val === 'calendar') return 1
    if (val === 'fiscal') return 2
    if (val === 'monthly') return 3
    return 0
}

export const InvoicePrefixScreen = () => {
    const { successToast, errorToast } = useNotification()

    // States
    const [tokens, setTokens] = useState([])
    const [separator, setSeparator] = useState('-')
    const [resetMode, setResetMode] = useState('never')
    const [fyStart, setFyStart] = useState('4')
    const [preview, setPreview] = useState('—')

    const [loading, setLoading] = useState(true)
    const [saving, setSaving] = useState(false)
    const [loadingPreview, setLoadingPreview] = useState(false)
    const [draggedIndex, setDraggedIndex] = useState(null)

    // 1. Inject Styles into Head on Mount
    useEffect(() => {
        const styleId = 'invoice-prefix-builder-styles'
        if (!document.getElementById(styleId)) {
            const styleElement = document.createElement('style')
            styleElement.id = styleId
            styleElement.innerHTML = formatBuilderStyles
            document.head.appendChild(styleElement)
        }
    }, [])

    // 2. Fetch configuration on Mount
    useEffect(() => {
        const fetchConfig = async () => {
            try {
                setLoading(true)
                const res = await CompanyInvoiceSettingService.getNumberFormat()
                if (res) {
                    const {
                        TokenOrderCsv = 'PREFIX,YEAR,NUMBER',
                        EnabledMask = 25,
                        PrefixText = 'INV',
                        CustomerFormat = 0,
                        YearFormat = 2,
                        NumberPadWidth = 4,
                        Separator = '-',
                        ResetMode = 2,
                        FyStartMonth = 4,
                    } = res

                    setSeparator(Separator)
                    setResetMode(mapResetModeToValue(ResetMode))
                    setFyStart(String(FyStartMonth))

                    const defaultTokens = [
                        {
                            key: 'PREFIX',
                            label: 'Prefix',
                            hint: 'Static text at the start (e.g. INV, BILL)',
                            type: 'input',
                            value: PrefixText || 'INV',
                            enabled: (EnabledMask & 1) !== 0,
                        },
                        {
                            key: 'CUSTOMER',
                            label: 'Customer Name',
                            hint: 'Spaces removed automatically',
                            type: 'select',
                            options: [
                                { value: 'initials', label: 'Initials (AC)' },
                                { value: 'full', label: 'Full name (AcmeCorp)' },
                            ],
                            value: mapCustomerFormatToValue(CustomerFormat),
                            enabled: (EnabledMask & 2) !== 0,
                        },
                        {
                            key: 'YEAR',
                            label: 'Year',
                            hint: 'Dynamic — updates automatically each year',
                            type: 'select',
                            options: [
                                { value: 'YYYY', label: 'Calendar 4-digit (2026)' },
                                { value: 'YY', label: 'Calendar 2-digit (26)' },
                                { value: 'FY-YYYY', label: 'Financial 4-digit (2026-27)' },
                                { value: 'FY-YY', label: 'Financial 2-digit (26-27)' },
                            ],
                            value: mapYearFormatToValue(YearFormat),
                            enabled: (EnabledMask & 8) !== 0,
                        },
                        {
                            key: 'NUMBER',
                            label: 'Auto Number',
                            hint: 'Auto-incremented invoice number',
                            type: 'select',
                            options: [
                                { value: '0', label: 'No padding (1)' },
                                { value: '3', label: '3 digits (001)' },
                                { value: '4', label: '4 digits (0001)' },
                                { value: '5', label: '5 digits (00001)' },
                            ],
                            value: String(NumberPadWidth),
                            enabled: (EnabledMask & 16) !== 0,
                        },
                    ]

                    let ordered = []
                    if (TokenOrderCsv) {
                        const keys = TokenOrderCsv.split(',').map(k => k.trim().toUpperCase())
                        keys.forEach(k => {
                            const found = defaultTokens.find(t => t.key === k)
                            if (found) {
                                ordered.push({ ...found, enabled: true })
                            }
                        })
                        // Add remaining missing tokens as disabled
                        defaultTokens.forEach(t => {
                            if (!keys.includes(t.key)) {
                                ordered.push({ ...t, enabled: false })
                            }
                        })
                    } else {
                        ordered = defaultTokens
                    }

                    setTokens(ordered)
                }
            } catch (err) {
                console.error('Failed to load format settings', err)
                errorToast('Failed to load format settings')
            } finally {
                setLoading(false)
            }
        }
        fetchConfig()
    }, [])

    // 3. Payload builder for Preview/Save
    const buildPayload = (currentTokens, currentSep, currentResetMode, currentFyStart) => {
        const activeTokens = currentTokens.filter(t => t.enabled)
        const tokenOrderCsv = activeTokens.map(t => t.key).join(',')

        let enabledMask = 0
        if (currentTokens.find(t => t.key === 'PREFIX')?.enabled) enabledMask += 1
        if (currentTokens.find(t => t.key === 'CUSTOMER')?.enabled) enabledMask += 2
        if (currentTokens.find(t => t.key === 'YEAR')?.enabled) enabledMask += 8
        if (currentTokens.find(t => t.key === 'NUMBER')?.enabled) enabledMask += 16

        const prefixToken = currentTokens.find(t => t.key === 'PREFIX')
        const prefixText = prefixToken ? prefixToken.value : ''

        const customerToken = currentTokens.find(t => t.key === 'CUSTOMER')
        const customerFormat = customerToken ? mapCustomerValueToFormat(customerToken.value) : 0

        const yearToken = currentTokens.find(t => t.key === 'YEAR')
        const yearFormat = yearToken ? mapYearValueToFormat(yearToken.value) : 0

        const numberToken = currentTokens.find(t => t.key === 'NUMBER')
        const numberPadWidth = numberToken ? parseInt(numberToken.value, 10) : 4

        return {
            TokenOrderCsv: tokenOrderCsv,
            EnabledMask: enabledMask,
            PrefixText: prefixText,
            CustomerFormat: customerFormat,
            YearFormat: yearFormat,
            NumberPadWidth: numberPadWidth,
            Separator: currentSep,
            ResetMode: mapResetValueToMode(currentResetMode),
            FyStartMonth: parseInt(currentFyStart, 10),
        }
    }

    // 4. Update preview whenever state changes
    useEffect(() => {
        if (tokens.length === 0) {
            return undefined
        }

        const fetchPreview = async () => {
            try {
                setLoadingPreview(true)

                const payload = buildPayload(tokens, separator, resetMode, fyStart)

                const res = await CompanyInvoiceSettingService.getPreview(payload)

                const previewVal =
                    res?.Preview ||
                    res?.data?.Preview ||
                    (typeof res === 'string' ? res : '—')

                setPreview(previewVal)
            } catch (err) {
                console.error('Failed to get format preview', err)
            } finally {
                setLoadingPreview(false)
            }
        }

        const timer = setTimeout(() => {
            fetchPreview()
        }, 300)

        return () => {
            clearTimeout(timer)
        }
    }, [tokens, separator, resetMode, fyStart])

    // 5. Handlers
    const handleToggle = key => {
        const updated = tokens.map(t => {
            if (t.key === key) {
                return { ...t, enabled: !t.enabled }
            }
            return t
        })
        setTokens(updated)
    }

    const handleValueChange = (key, value) => {
        const updated = tokens.map(t => {
            if (t.key === key) {
                return { ...t, value }
            }
            return t
        })
        setTokens(updated)
    }

    const handleSeparatorChange = value => {
        const clean = value.substring(0, 3)
        setSeparator(clean)
    }

    // 6. Drag and Drop handlers
    const handleDragStart = (e, index) => {
        if (!tokens[index].enabled) return
        setDraggedIndex(index)
        e.dataTransfer.effectAllowed = 'move'
    }

    const handleDragOver = e => {
        e.preventDefault()
    }

    const handleDrop = (e, index) => {
        e.preventDefault()
        if (draggedIndex === null || draggedIndex === index) return

        const updated = [...tokens]
        const [removed] = updated.splice(draggedIndex, 1)
        updated.splice(index, 0, removed)

        setTokens(updated)
        setDraggedIndex(null)
    }

    const handleDragEnd = () => {
        setDraggedIndex(null)
    }

    // 7. Save handler
    const handleSave = async () => {
        try {
            setSaving(true)
            const payload = buildPayload(tokens, separator, resetMode, fyStart)
            await CompanyInvoiceSettingService.saveNumberFormat(payload)
            successToast('Invoice prefix and format saved successfully')
        } catch (err) {
            console.error('Failed to save format settings', err)
            errorToast('Failed to save format settings')
        } finally {
            setSaving(false)
        }
    }

    // Format String Preview (for display card)
    const formatStringPreview = () => {
        return tokens
            .filter(t => t.enabled)
            .map(t => {
                if (t.key === 'PREFIX') return t.value.replace(/\s+/g, '')
                return `{${t.key}}`
            })
            .filter(Boolean)
            .join(separator) || '—'
    }

    const hasFY = resetMode === 'fiscal' || tokens.some(t => t.key === 'YEAR' && t.enabled && t.value.includes('FY'))

    if (loading) {
        return (
            <Segment basic style={{ minHeight: '300px' }} loading>
                <div style={{ padding: '60px', textAlign: 'center', color: '#667085' }}>Loading Format Settings...</div>
            </Segment>
        )
    }

    return (
        <div className="format-builder-wrap">
            <h1>Invoice Number Prefix & Format</h1>
            <div className="subtitle">
                Toggle parts on or off. Drag the <span style={{ color: '#6c757d', fontWeight: '600' }}>⋮⋮</span> handle to reorder.
            </div>

            {/* PREVIEW CARD */}
            <div className="fb-card preview-card" style={{ position: 'relative' }}>
                {loadingPreview && (
                    <div style={{ position: 'absolute', top: '10px', right: '10px', fontSize: '11px', color: '#84caff' }}>
                        Updating...
                    </div>
                )}
                <div className="preview-label">
                    Live Preview <span style={{ fontWeight: '400', textTransform: 'none', letterSpacing: 0, color: '#98a2b3' }}>— rendered from backend</span>
                </div>
                <div className="preview-box">{preview}</div>
                <div className="preview-sub" style={{ marginTop: '8px' }}>Format String: <span className="format-string">{formatStringPreview()}</span></div>
            </div>

            {/* TOKENS CARD */}
            <div className="fb-card">
                <div className="row-list">
                    {tokens.map((t, idx) => {
                        const isDragging = idx === draggedIndex
                        return (
                            <div
                                key={t.key}
                                className={`fb-row ${!t.enabled ? 'disabled' : ''} ${isDragging ? 'dragging' : ''}`}
                                draggable={t.enabled}
                                onDragStart={e => handleDragStart(e, idx)}
                                onDragOver={handleDragOver}
                                onDrop={e => handleDrop(e, idx)}
                                onDragEnd={handleDragEnd}
                            >
                                <span
                                    className="drag-handle"
                                    style={{ cursor: t.enabled ? 'grab' : 'not-allowed' }}
                                    title={t.enabled ? 'Drag to reorder' : 'Enable part to reorder'}
                                >
                                    ⋮⋮
                                </span>

                                <div
                                    className={`fb-toggle ${t.enabled ? 'on' : ''}`}
                                    onClick={() => handleToggle(t.key)}
                                >
                                    <div className="fb-toggle-knob" />
                                </div>

                                <label className="row-label">
                                    {t.label}
                                    <span className="hint">{t.hint}</span>
                                </label>

                                <div className="row-control">
                                    {t.type === 'input' ? (
                                        <Input
                                            type="text"
                                            value={t.value}
                                            disabled={!t.enabled}
                                            maxLength={t.key === 'PREFIX' ? 10 : 30}
                                            onChange={e => handleValueChange(t.key, e.target.value)}
                                            style={{ minWidth: '200px' }}
                                        />
                                    ) : (
                                        <Dropdown
                                            selection
                                            disabled={!t.enabled}
                                            value={t.value}
                                            options={t.options.map(o => ({ key: o.value, value: o.value, text: o.label }))}
                                            onChange={(_, data) => handleValueChange(t.key, data.value)}
                                            style={{ minWidth: '200px' }}
                                        />
                                    )}
                                </div>
                            </div>
                        )
                    })}
                </div>

                {/* GLOBAL OPTIONS SECTION */}
                <div className="global-section">
                    <div className="global-row">
                        <label className="row-label">
                            Separator
                            <span className="hint">Character between parts</span>
                        </label>
                        <Input
                            type="text"
                            value={separator}
                            maxLength={3}
                            onChange={e => handleSeparatorChange(e.target.value)}
                            style={{ minWidth: '240px' }}
                        />
                    </div>

                    <div className="global-row">
                        <label className="row-label">
                            Reset auto number
                            <span className="hint">When the counter restarts from 1</span>
                        </label>
                        <Dropdown
                            selection
                            value={resetMode}
                            options={[
                                { key: 'never', value: 'never', text: 'Never' },
                                { key: 'calendar', value: 'calendar', text: 'Every calendar year (1 Jan)' },
                                { key: 'fiscal', value: 'fiscal', text: 'Every financial year' },
                                { key: 'monthly', value: 'monthly', text: 'Every month' },
                            ]}
                            onChange={(_, data) => setResetMode(data.value)}
                            style={{ minWidth: '240px' }}
                        />
                    </div>

                    {hasFY && (
                        <div className="global-row">
                            <label className="row-label">
                                Financial year starts
                                <span className="hint">Used for FY year display and FY reset</span>
                            </label>
                            <Dropdown
                                selection
                                value={fyStart}
                                options={[
                                    { key: '1', value: '1', text: 'January' },
                                    { key: '4', value: '4', text: 'April (IN, UK)' },
                                    { key: '7', value: '7', text: 'July (AU)' },
                                    { key: '10', value: '10', text: 'October (US Federal)' },
                                ]}
                                onChange={(_, data) => setFyStart(data.value)}
                                style={{ minWidth: '240px' }}
                            />
                        </div>
                    )}
                </div>
            </div>

            <SubmitCancelButtons loading={saving} onSubmit={handleSave} onCancel={() => { }} />
        </div>
    )
}
